/* @flow */

import React from 'react';
import t from 'app/utils/translate';
import DepositLink from '../links/DepositLink';
import NavBarFlat from '../commons/NavBarFlat';
import NavBarItemFlat from '../commons/NavBarItemFlat';
import Responsive from '../responsive/Responsive';
import Icon from '../commons/Icon';

type Props = {
  enableAccountLimit: boolean,
  isActive?: boolean,
  isFreeOnly?: boolean
};

const defaultProps = {
  isActive: false,
  isFreeOnly: false
};

function AccountMenu({ enableAccountLimit, isActive, isFreeOnly }: Props) {
  return (
    <Responsive mobile>
      {isMobile => (
        <NavBarFlat>
          <NavBarItemFlat link="/account/profile">{isMobile ? 'You' : 'Profile'}</NavBarItemFlat>
          {!isFreeOnly && <NavBarItemFlat component={DepositLink}>{t('Deposit')}</NavBarItemFlat>}
          {!isFreeOnly && (
            <NavBarItemFlat link="/account/withdraw">
              {isMobile ? 'w/d' : 'Withdraw'}
            </NavBarItemFlat>
          )}
          {!isFreeOnly && (
            <NavBarItemFlat link="/account/transactions">
              {isMobile ? 'TXNS' : 'Transactions'}
            </NavBarItemFlat>
          )}
          <NavBarItemFlat link="/account/history">{isMobile ? 'Hist' : 'History'}</NavBarItemFlat>
          {enableAccountLimit && <NavBarItemFlat link="/account/limits">Limits</NavBarItemFlat>}
          {enableAccountLimit && (
            <NavBarItemFlat link="/account/take-a-break">
              {isMobile ? 'T/B' : 'Take A Break'}
            </NavBarItemFlat>
          )}
          {enableAccountLimit && (
            <NavBarItemFlat link="/account/self-exclusion">
              {isMobile ? 'S/E' : 'Self Exclusion'}
            </NavBarItemFlat>
          )}
          <NavBarItemFlat link="/account/settings">
            {isMobile ? <Icon type="icon-cog-solid" /> : 'Settings'}
          </NavBarItemFlat>
        </NavBarFlat>
      )}
    </Responsive>
  );
}

AccountMenu.defaultProps = defaultProps;

export default AccountMenu;
